import { c as _c } from "react/compiler-runtime";
import { Progress } from "@/components/ui/progress";
import { Home, Square, TreeDeciduous } from "lucide-react";
import { useTranslations } from "next-intl";
type Props = {
  totalArea: number;
  privateUsableArea?: number;
  dependableUsableArea?: number;
  plotArea?: number;
  usableArea?: number;
  terraceArea?: number;
  salePrice?: number;
};
export function AreaContent(t0) {
  const $ = _c(65);
  const {
    totalArea,
    privateUsableArea,
    dependableUsableArea,
    plotArea,
    usableArea,
    terraceArea,
    salePrice
  } = t0;
  const t = useTranslations("modules.realEstateDetail");
  const buildingPct = privateUsableArea ? privateUsableArea / totalArea * 100 : 0;
  const plotAreaPct = plotArea ? plotArea / totalArea * 100 : 0;
  const terraceAreaPct = terraceArea ? terraceArea / totalArea * 100 : 0;
  const dependableUsableAreaPct = dependableUsableArea ? dependableUsableArea / totalArea * 100 : 0;
  const usableAreaPct = usableArea ? usableArea / totalArea * 100 : 0;
  let t1;
  if ($[0] !== t) {
    t1 = t("totalArea");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <p className="text-sm text-muted-foreground">{t1}</p>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== totalArea) {
    t3 = <p className="text-foreground text-xl font-semibold">{totalArea} m²</p>;
    $[4] = totalArea;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="flex flex-col justify-center items-center w-full">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("usableArea");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <p className="text-sm text-muted-foreground">{t5}</p>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = privateUsableArea + usableArea;
  let t8;
  if ($[13] !== t7) {
    t8 = <p className="text-foreground text-xl font-semibold">{t7} m²</p>;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t6 || $[16] !== t8) {
    t9 = <div className="flex flex-col justify-center items-center w-full">{t6}{t8}</div>;
    $[15] = t6;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t4 || $[19] !== t9) {
    t10 = <div className="flex rounded-lg border border-border p-4 divide-x divide-border">{t4}{t9}</div>;
    $[18] = t4;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== buildingPct || $[22] !== privateUsableArea || $[23] !== t) {
    t11 = privateUsableArea && <div className="flex flex-col gap-2"><div className="flex items-center gap-2"><div className="flex items-center justify-center rounded-md bg-primary p-1.5"><Home className="text-white w-4 h-4" /></div><span className="font-semibold">{t("buildingArea")}</span><span className="ml-auto text-xs text-muted-foreground">{privateUsableArea} m² ({buildingPct.toFixed(1)}%)</span></div><Progress value={buildingPct} /></div>;
    $[21] = buildingPct;
    $[22] = privateUsableArea;
    $[23] = t;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t || $[26] !== usableArea || $[27] !== usableAreaPct) {
    t12 = usableArea && <div className="flex flex-col gap-2"><div className="flex items-center gap-2"><div className="flex items-center justify-center rounded-md bg-primary p-1.5"><Home className="text-white w-4 h-4" /></div><span className="font-semibold">{t("usableArea")}</span><span className="ml-auto text-xs text-muted-foreground">{usableArea} m² ({usableAreaPct.toFixed(1)}%)</span></div><Progress value={usableAreaPct} /></div>;
    $[25] = t;
    $[26] = usableArea;
    $[27] = usableAreaPct;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== plotArea || $[30] !== plotAreaPct || $[31] !== t) {
    t13 = plotArea && <div className="flex flex-col gap-2"><div className="flex items-center gap-2"><div className="flex items-center justify-center rounded-md bg-primary/60 p-1.5"><TreeDeciduous className="text-white w-4 h-4" /></div><span className="font-semibold">{t("plotArea")}</span><span className="ml-auto text-xs text-muted-foreground">{plotArea} m² ({plotAreaPct.toFixed(1)}%)</span></div><Progress value={plotAreaPct} /></div>;
    $[29] = plotArea;
    $[30] = plotAreaPct;
    $[31] = t;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t || $[34] !== terraceArea || $[35] !== terraceAreaPct) {
    t14 = terraceArea && <div className="flex flex-col gap-2"><div className="flex items-center gap-2"><div className="flex items-center justify-center rounded-md bg-primary/60 p-1.5"><Square className="text-white w-4 h-4" /></div><span className="font-semibold">{t("terraceArea")}</span><span className="ml-auto text-xs text-muted-foreground">{terraceArea} m² ({terraceAreaPct.toFixed(1)}%)</span></div><Progress value={terraceAreaPct} /></div>;
    $[33] = t;
    $[34] = terraceArea;
    $[35] = terraceAreaPct;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== dependableUsableArea || $[38] !== dependableUsableAreaPct || $[39] !== t) {
    t15 = dependableUsableArea && <div className="flex flex-col gap-2"><div className="flex items-center gap-2"><div className="flex items-center justify-center rounded-md bg-primary/60 p-1.5"><TreeDeciduous className="text-white w-4 h-4" /></div><span className="font-semibold">{t("dependableUsableArea")}</span><span className="ml-auto text-xs text-muted-foreground">{dependableUsableArea} m² ({dependableUsableAreaPct.toFixed(1)}%)</span></div><Progress value={dependableUsableAreaPct} /></div>;
    $[37] = dependableUsableArea;
    $[38] = dependableUsableAreaPct;
    $[39] = t;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== t11 || $[42] !== t12 || $[43] !== t13 || $[44] !== t14 || $[45] !== t15) {
    t16 = <div className="flex flex-col gap-4 mt-6">{t11}{t12}{t13}{t14}{t15}</div>;
    $[41] = t11;
    $[42] = t12;
    $[43] = t13;
    $[44] = t14;
    $[45] = t15;
    $[46] = t16;
  } else {
    t16 = $[46];
  }
  let t17;
  if ($[47] !== t) {
    t17 = t("pricePerSqm");
    $[47] = t;
    $[48] = t17;
  } else {
    t17 = $[48];
  }
  let t18;
  if ($[49] !== t17) {
    t18 = <span className="text-xs text-muted-foreground">{t17}</span>;
    $[49] = t17;
    $[50] = t18;
  } else {
    t18 = $[50];
  }
  const t19 = salePrice / totalArea;
  let t20;
  if ($[51] !== t19) {
    t20 = t19.toFixed(1);
    $[51] = t19;
    $[52] = t20;
  } else {
    t20 = $[52];
  }
  let t21;
  if ($[53] !== t) {
    t21 = t("euroPricePerSqm");
    $[53] = t;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  let t22;
  if ($[55] !== t20 || $[56] !== t21) {
    t22 = <span className="font-bold text-lg text-foreground">{t20} {t21}</span>;
    $[55] = t20;
    $[56] = t21;
    $[57] = t22;
  } else {
    t22 = $[57];
  }
  let t23;
  if ($[58] !== t18 || $[59] !== t22) {
    t23 = <div className="flex flex-col items-center mt-6 border-t border-border pt-4">{t18}{t22}</div>;
    $[58] = t18;
    $[59] = t22;
    $[60] = t23;
  } else {
    t23 = $[60];
  }
  let t24;
  if ($[61] !== t10 || $[62] !== t16 || $[63] !== t23) {
    t24 = <div className="w-full" data-sentry-component="AreaContent" data-sentry-source-file="AreaContent.tsx">{t10}{t16}{t23}</div>;
    $[61] = t10;
    $[62] = t16;
    $[63] = t23;
    $[64] = t24;
  } else {
    t24 = $[64];
  }
  return t24;
}